/*
 * yojo-pdp.js — Wave A v2 (2026-04-20)
 *
 * Flavor-pdp shell behavior:
 *   - Variant-change: updates price, compare-at, helper, ATC label
 *   - AJAX cart submit via fetch → /cart/add.js
 *
 * Mix-mode (Wave B, 2026-04-20) RETIRED 2026-07-02 (audit #5, owner-approved):
 * mix parent products (moz-mix / paletas-mix) are archived, so the toggle,
 * slot grid, flavor picker, mix JSON parsing, and the mix ATC path were
 * removed. Single-flavor + pack-size flow is unchanged.
 */

(function () {
  'use strict';

  function moneyFormat(cents) {
    if (cents == null) return '';
    var n = Math.round(cents) / 100;
    var str = n.toFixed(2);
    return str + ' \u20AA';
  }

  // 2026-10-02 (swarm b3-pdp): whole shekels without ".00", the shape of Liquid's
  // money_without_trailing_zeros on this store ("21 \u20AA", "16.50 \u20AA"). Used where the form
  // prints its prices that way (data-price-format="whole", the weight form), so a size
  // change keeps the card format of the 26 Sep ruling.
  function moneyShort(cents) {
    if (cents == null) return '';
    var n = Math.round(cents) / 100;
    return (n % 1 === 0 ? String(n) : n.toFixed(2)) + ' \u20AA';
  }

  // 2026-10-02 (a11y ruling R5): what a screen reader is told is written for the ear.
  // "\u05E7\u05F4\u05D2" and "\u05E7"\u05D2" are read as letters or "quote", never "\u05E7\u05D9\u05DC\u05D5"; "/ 100 \u05D2\u05F3" as "\u05D2\u05D9\u05DE\u05DC".
  function spoken(s) {
    return String(s || '')
      .replace(/ק["״]ג/g, 'קילו')
      .replace(/מ["״]ל/g, 'מיליליטר')
      .replace(/ס["״]מ/g, 'סנטימטר')
      .replace(/\/\s*100\s*ג['׳]/g, 'ל-100 גרם')
      .replace(/(\d)\s*ג['׳]/g, '$1 גרם')
      // R5: prices without trailing zeros ("15.00 ₪ ליחידה" is read "15 נקודה אפס אפס").
      .replace(/(\d+)\.00(?=\s*₪)/g, '$1')
      .replace(/\s+/g, ' ')
      .trim();
  }

  function parseJson(el) {
    if (!el) return null;
    try { return JSON.parse(el.textContent.trim()); }
    catch (e) { return null; }
  }

  function initOne(root) {
    if (!root || root.__yojoPdpInit) return;
    root.__yojoPdpInit = true;

    var productData = parseJson(root.querySelector('[data-js-product-json]'));

    var priceNow = root.querySelector('[data-js-pdp-price-now]');
    var priceWas = root.querySelector('[data-js-pdp-price-was]');
    var packSubtitle = root.querySelector('[data-js-pdp-subtitle]');
    var perUnitAmount = root.querySelector('[data-js-pdp-per-unit-amount]');
    var perUnitQty = root.querySelector('[data-js-pdp-per-unit-qty]');
    var perUnitWrap = root.querySelector('[data-js-pdp-per-unit]');
    var helperQty = root.querySelector('[data-js-pack-qty]');
    var atc = root.querySelector('[data-js-atc]');
    var atcLabel = atc ? atc.querySelector('.yojo-pdp__atc-label') : null;
    var form = root.querySelector('[data-js-product-form]');
    var radios = root.querySelectorAll('input.yojo-pdp__pack-input');
    var packInstr = root.querySelector('[data-js-pack-instruction]');
    // Both forms print whole shekels (data-price-format="whole"; the flavour form since vf-K7,
    // T-S14, 2026-10-02); moneyFormat stays the fallback for markup without the attribute.
    var priceFmt = root.querySelector('[data-js-pdp-price][data-price-format="whole"]') ? moneyShort : moneyFormat;
    var titleEl = root.querySelector('.yojo-pdp__title');

    // Audit #17 (2026-07-02): ATC labels come from the form's data attributes —
    // single source is locales/he.json (products.page.add_to_cart_button /
    // products.page.inventory.sold_out_variant), rendered by the Liquid form.
    // The string literals below are last-resort fallbacks matching those keys.
    var ATC_ADD = (form && form.getAttribute('data-atc-label')) || 'הוספה לסל';
    var ATC_SOLDOUT = (form && form.getAttribute('data-atc-soldout')) || 'אזל מהמלאי';

    var state = {
      variantId: null,
      // Gate for the live-region announcement below: stays false through the
      // initial updateFromRadio() sync, flips true once the customer can interact.
      announceReady: false,
      announceTimer: null
    };

    function currentRadio() {
      return root.querySelector('input.yojo-pdp__pack-input:checked');
    }

    function variantById(id) {
      if (!productData) return null;
      return productData.variants.find(function (x) { return String(x.id) === String(id); });
    }

    function updateFromRadio(r) {
      if (!r || !productData) return;
      var v = variantById(r.value);
      if (!v) return;

      state.variantId = r.value;
      var subtitle = r.getAttribute('data-pack-subtitle');
      if (packSubtitle && subtitle) packSubtitle.textContent = subtitle;

      // 2026-08-05 audit fix: a variant with its own featured image (pack
      // composites) swaps the hero — same srcset-drop pattern as the thumb
      // handler below, so the src actually wins.
      var packImg = r.getAttribute('data-pack-image');
      var heroImg = root.querySelector('.yojo-pdp__image');
      if (heroImg) {
        if (!heroImg.dataset.baseSrc) heroImg.dataset.baseSrc = heroImg.currentSrc || heroImg.src;
        var target = packImg || heroImg.dataset.baseSrc;
        // 2026-09-29 (audit pdp-pass F8): this ran on load for every weight PDP and replaced the
        // responsive hero with a fixed 1200w URL, so phones fetched the photo twice (600w, then
        // 1200w at 123 KB). Same photo (URL without its width) -> no swap. A different photo keeps
        // a srcset so the `sizes` in yojo-pdp-media.liquid still picks the phone file.
        var noWidth = function (u) { return String(u || '').replace(/([?&])width=\d+&?/, '$1').replace(/[?&]$/, ''); };
        var withWidth = function (u, w) { return /[?&]width=\d+/.test(u) ? u.replace(/([?&])width=\d+/, '$1width=' + w) : u + (u.indexOf('?') === -1 ? '?' : '&') + 'width=' + w; };
        if (target && noWidth(target) !== noWidth(heroImg.currentSrc || heroImg.src)) {
          heroImg.srcset = [600, 900, 1200, 1600].map(function (w) { return withWidth(target, w) + ' ' + w + 'w'; }).join(', ');
          heroImg.src = withWidth(target, 1200);
        }
      }

      if (priceNow) priceNow.textContent = priceFmt(v.price);
      if (priceWas) {
        if (v.compare_at_price && v.compare_at_price > v.price) {
          priceWas.textContent = priceFmt(v.compare_at_price);
          priceWas.removeAttribute('hidden');
        } else {
          priceWas.setAttribute('hidden', '');
          priceWas.textContent = '';
        }
      }
      if (perUnitWrap) {
        // Weight products show ₪ / 100 ג׳ (data-per-100g, in cents; 2026-08-22, was
        // data-per-kg). data-per-kg is still read as a fallback for any cached
        // markup, but the label is server-rendered so a stale attribute would
        // only show a 10x number, never a wrong unit. Packs show ₪ per unit.
        var perKgUnit = parseInt(r.getAttribute('data-per-100g') || r.getAttribute('data-per-kg') || '0', 10) || 0;
        var packQtyForUnit = parseInt(r.getAttribute('data-pack-qty') || '0', 10) || 0;
        if (perKgUnit > 0) {
          if (perUnitAmount) perUnitAmount.textContent = priceFmt(perKgUnit);
          perUnitWrap.removeAttribute('hidden');
        } else if (packQtyForUnit > 1 && v.price > 0) {
          if (perUnitAmount) perUnitAmount.textContent = priceFmt(v.price / packQtyForUnit);
          if (perUnitQty) perUnitQty.textContent = String(packQtyForUnit);
          perUnitWrap.removeAttribute('hidden');
        } else {
          perUnitWrap.setAttribute('hidden', '');
        }
        // Belt-and-braces (2026-08-01): a variant with no unit data left the
        // wrapper visible with an empty amount and a bare "ליחידה" label
        // (seen on coconut-cream-aroy-d). If there is no number, there is no
        // line.
        if (perUnitAmount && !perUnitAmount.textContent.trim()) {
          perUnitWrap.setAttribute('hidden', '');
        }
      }
      if (helperQty) helperQty.textContent = v.title;

      // A11y (2026-08-01, PDP re-arch): announce the new selection.
      // MEASURED GAP: on all 5 archetypes probed, changing pack size rewrote the
      // price (₪110 → ₪300), the compare-at, the per-unit line and the ATC state
      // with ZERO output to any live region — a WCAG 2.2 4.1.3 (Status Messages)
      // failure, and the single largest change on the page for a screen-reader
      // user. #screen-reader-info is the theme's existing polite live region
      // (already used by this file's cart-error path), so no new region is added.
      // Skipped on the first paint: updateFromRadio() is called once at init to
      // sync the server-rendered state, and announcing then would talk over the
      // page load.
      // 2026-10-02 (a11y ruling R5): spoken units and prices, e.g. "1 קילו, 38 ₪, 3.80 ₪ ל-100 גרם".
      if (state.announceReady) {
        var srLive = document.getElementById('screen-reader-info');
        if (srLive) {
          var parts = [spoken(v.title), moneyShort(v.price)];
          if (perUnitWrap && !perUnitWrap.hasAttribute('hidden')) {
            parts.push(spoken(perUnitWrap.textContent));
          }
          if (v.available === false) parts.push(ATC_SOLDOUT);
          srLive.textContent = parts.join(', ');
          clearTimeout(state.announceTimer);
          state.announceTimer = setTimeout(function () { srLive.textContent = ''; }, 4000);
        }
      }

      // Pack-format integrity (2026-07-03): keep the line-item pack instruction in sync with the
      // selected size so the order tells logistics the exact bags to pack (never substitute by weight).
      if (packInstr) {
        var pi = r.getAttribute('data-pack-instruction');
        if (pi) packInstr.value = pi;
      }

      updateAtcState(v);
      syncUrl(v.id);
    }

    function syncUrl(vid) {
      try {
        var u = new URL(window.location.href);
        u.searchParams.set('variant', String(vid));
        window.history.replaceState({}, '', u.toString());
      } catch (e) { /* no-op */ }
    }

    function updateAtcState(v) {
      if (!atc) return;
      var available = v ? v.available !== false : true;
      setAtc(!available, available ? ATC_ADD : ATC_SOLDOUT);
    }

    function setAtc(disabled, label) {
      if (!atc) return;
      if (disabled) {
        atc.setAttribute('disabled', '');
        atc.classList.add('is-disabled');
      } else {
        atc.removeAttribute('disabled');
        atc.classList.remove('is-disabled');
      }
      if (atcLabel && label) atcLabel.textContent = label;
    }

    radios.forEach(function (r) {
      r.addEventListener('change', function () { if (r.checked) updateFromRadio(r); });
    });

    // 2026-10-02 (swarm b3-pdp; a11y ruling R8, "one message per add"; cart-a11y handoff).
    // This file used to write the generic "המוצר נוסף לסל" the moment an add landed, and
    // yojo-a11y-cart-announcer.js (the one writer for cart changes) then said
    // "נוסף לסל: <product>." 300 to 460 ms later, so every PDP add was spoken twice.
    // The announcer now speaks alone. This path still owns the promise that an add is
    // announced: if no cart line reaches the live region within 3 s (the announcer's
    // /cart.js read failed or was throttled), it says the specific line itself, with
    // the size spoken (R5): "נוסף לסל: אוכמניות כחולות קפואות, 2 קילו."
    // 2026-10-02 (swarm f3-pdp, r3 review): the watch starts when the add is SENT. On a slow
    // answer the announcer spoke first (measured: its line 1.2 s before the add's answer), a
    // watch started on the answer missed it, and 3 s later the fallback said a second line.
    var ADD_ANNOUNCE_WAIT_MS = 3000;
    var CART_LINE = /^(נוסף לסל|נוספה לסל|עודכנה כמות|הסל עודכן)/;
    function watchCartLine() {
      var sr = document.getElementById('screen-reader-info');
      var heard = false, mo = null;
      if (sr && window.MutationObserver) {
        mo = new MutationObserver(function () {
          if (CART_LINE.test((sr.textContent || '').trim())) heard = true;
        });
        mo.observe(sr, { childList: true, characterData: true, subtree: true });
      }
      function stop() { if (mo) { mo.disconnect(); mo = null; } }
      return {
        stop: stop,
        // After a successful add: speak `text` only if no cart line has been heard 3 s from now.
        settle: function (text) {
          if (!sr) { stop(); return; }
          setTimeout(function () {
            stop();
            if (heard) return;
            sr.textContent = '';
            setTimeout(function () {
              sr.textContent = text;
              setTimeout(function () { if (sr.textContent === text) sr.textContent = ''; }, 4000);
            }, 30);
          }, ADD_ANNOUNCE_WAIT_MS);
        }
      };
    }

    if (form) {
      form.addEventListener('submit', function (e) {
        // Issue #2 · Principle P1 — handle BOTH single-variant and multi-variant PDPs.
        // Single-variant products carry the variant id in a hidden <input name="id">
        // and have NO .yojo-pdp__pack-input radios. Previous code returned early when
        // no radio was checked, allowing native form submission (full page nav to
        // /cart) for every single-variant product. That defeated the entire AJAX path
        // for the most common product type.
        var checked = currentRadio();
        var hasRadios = !!root.querySelector('input.yojo-pdp__pack-input');
        if (hasRadios && !checked) { e.preventDefault(); return; }
        if (checked && checked.disabled) { e.preventDefault(); return; }

        e.preventDefault();
        if (atc) { atc.setAttribute('disabled', ''); atc.classList.add('is-working'); }

        var addSucceeded = false;
        var fd = new FormData(form);
        // Only override id from radio for multi-variant; single-variant uses hidden input as-is.
        if (checked) fd.set('id', checked.value);
        // 2026-10-02 (swarm c06 finding 4, a15-F5): one round trip. The add asks for the drawer
        // section in the same response (Section Rendering API, as the card "+" and the size
        // sheet already do); the separate ?section_id=helper-cart GET below is only the
        // fallback for a response without it.
        fd.set('sections', 'helper-cart');
        fd.set('sections_url', window.location.pathname);
        var addedText = 'נוסף לסל: ' + (titleEl ? titleEl.textContent.replace(/\s+/g, ' ').trim() : '') +
          (checked && checked.getAttribute('data-pack-title') ? ', ' + spoken(checked.getAttribute('data-pack-title')) : '') + '.';
        // A size picked in the last 4 s must not blank the add's line: its clear timer goes now
        // (r3 review measured the announcer's line wiped 1 s after it was written).
        clearTimeout(state.announceTimer);
        var addWatch = watchCartLine();

        // Checkout hardening 2026-08-25: announce this mutation to the shared
        // in-flight counter (component-cart.js) so window.refreshCart's
        // focus/pageshow repaint cannot read the cart mid-add and overwrite
        // this chain's fresh render with pre-add state.
        window._yojoCartMutationsInFlight = (window._yojoCartMutationsInFlight || 0) + 1;

        fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Accept': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
          body: fd
        })
          .then(function (res) {
            // 2026-08-09: `res.json()` on a NON-JSON error body (a Cloudflare
            // challenge page, a 5xx, any WAF interstitial) rejects with a
            // SyntaxError, which is not a yojoServerRejection — so it used to
            // skip the inline error this code already builds and fall through to
            // `form.submit()`, a native POST that dumps the shopper on the raw
            // /cart/add endpoint. Observed: one click produced two POSTs and a
            // navigation to https://yojo.co.il/cart/add. Read the body as TEXT
            // and decide from the STATUS, so a non-JSON failure is still a
            // server rejection with a readable message.
            return res.text().then(function (body) {
              var j = null;
              try { j = JSON.parse(body); } catch (e) { j = null; }
              return { ok: res.ok, status: res.status, j: j };
            });
          })
          .then(function (result) {
            if (!result.ok) {
              // Shopify's rejection strings are English on a Hebrew storefront —
              // the stock clamp answers "Only 26 items were added to your cart
              // due to availability." Localise the one case a shopper actually
              // meets; anything else falls back to our own Hebrew line rather
              // than surfacing raw platform English.
              var raw = (result.j && (result.j.description || result.j.message)) || '';
              var msgOut = 'לא הצלחנו להוסיף לסל כרגע. נסו שוב עוד רגע.';
              var clamp = /Only\s+(\d+)\s+items?\s+were added/i.exec(raw);
              if (clamp) {
                msgOut = 'נשארו במלאי ' + clamp[1] + ' יחידות בלבד, והוספנו את מה שיש.';
              } else if (raw && !/[A-Za-z]/.test(raw)) {
                msgOut = raw;
              }
              var rejection = new Error(msgOut);
              rejection.yojoServerRejection = true;
              throw rejection;
            }
            // From here on the item IS in the cart. Nothing downstream may
            // re-submit the form.
            addSucceeded = true;
            // S-03: a refusal from an earlier tap no longer applies once an add lands.
            var staleErr = form.querySelector('.yojo-pdp__atc-error');
            if (staleErr) staleErr.remove();
            // The add is announced from here, whatever happens to the render below (the
            // statement promises it). One message per add: see watchCartLine.
            addWatch.settle(addedText);
            // Issue #2 · Principle P1 — refresh AjaxCartForm content + open YOJO cart drawer.
            // Mirrors the working pattern in component-product-form.js used by quick-buy
            // and product-recommendations. Previous selectors ([data-js-cart-drawer],
            // cart-drawer, #cart-drawer) didn't match YOJO's actual drawer ID
            // (#site-cart-sidebar), so this branch fell through to window.location.href
            // = '/cart' on every PDP add — full page reload, lost scroll, lost recs rail.
            var sectionHtml = result.j && result.j.sections && result.j.sections['helper-cart'];
            if (typeof sectionHtml === 'string' && sectionHtml) return sectionHtml;
            return fetch('?section_id=helper-cart').then(function (r) { return r.text(); });
          })
          .then(function (text) {
            if (typeof text !== 'string') return;
            var doc = new DOMParser().parseFromString(text, 'text/html');
            // Capture header-count + total text BEFORE replaceChildren below moves these
            // nodes from `doc` into the live document — after the move, `doc.querySelector`
            // returns null and the header propagation silently no-ops, leaving the cart
            // counter stuck at "0" after every ATC click (customer-visible regression).
            var newCountEl = doc.querySelector('[data-cart-count]');
            var newTotalEl = doc.querySelector('[data-cart-total]');
            var newCountText = newCountEl ? newCountEl.textContent : null;
            var newTotalText = newTotalEl ? newTotalEl.textContent : null;
            var ajaxCartForm = document.getElementById('AjaxCartForm');
            var newCartFormInner = doc.getElementById('AjaxCartForm');
            if (ajaxCartForm && newCartFormInner) {
              // Use replaceChildren with DOM nodes, not innerHTML, for safe replacement.
              // Content is server-rendered same-origin theme HTML — no untrusted input.
              ajaxCartForm.replaceChildren.apply(ajaxCartForm, Array.prototype.slice.call(newCartFormInner.childNodes));
              if (typeof ajaxCartForm.ajaxifyCartItems === 'function') ajaxCartForm.ajaxifyCartItems();
              if (typeof window.yojoReplaceCartSubtotal === 'function') {
                window.yojoReplaceCartSubtotal(doc);
              } else {
                var subtotalEl = document.getElementById('AjaxCartSubtotal');
                var newSubtotalEl = doc.getElementById('AjaxCartSubtotal');
                if (subtotalEl && newSubtotalEl) {
                  subtotalEl.replaceChildren.apply(subtotalEl, Array.prototype.slice.call(newSubtotalEl.childNodes));
                }
              }
            }
            if (newCountText !== null) document.querySelectorAll('[data-header-cart-count]').forEach(function (el) { el.textContent = newCountText; });
            if (newTotalText !== null) document.querySelectorAll('[data-header-cart-total]').forEach(function (el) { el.textContent = newTotalText; });
            if (!document.body.classList.contains('template-cart')) {
              var siteCart = document.getElementById('site-cart-sidebar');
              if (siteCart && typeof siteCart.show === 'function') siteCart.show();
              // 2026-10-14 gift ladder (C8): the ladder sits at the top of the
              // drawer body, so a product-page add lands there, as quick-add
              // already does. Only while the ladder renders (switch on).
              if (siteCart && siteCart.querySelector('[data-yojo-ladder]')) {
                try {
                  if (typeof siteCart.scrollTo === 'function') siteCart.scrollTo({ top: 0 });
                  var drawerBody = siteCart.querySelector('.sidebar__body');
                  if (drawerBody) drawerBody.scrollTop = 0;
                } catch (e) { /* scrolling is cosmetic */ }
              }
            }
            // 2026-10-02 (swarm c06 finding 4): the drawer suggestions are rebuilt once, by
            // component-cart-recommendations.js on 'cart:updated'. A direct
            // generateRecommendations() call here rebuilt them a second time on every add.
            document.dispatchEvent(new CustomEvent('cart:updated'));
            document.dispatchEvent(new CustomEvent('product:added'));
          })
          .catch(function (err) {
            if (!addSucceeded) addWatch.stop();
            console.warn('[yojo-pdp] cart add failed', err);
            var msg = (err && err.message && err.message !== 'cart/add failed') ? err.message : 'לא הצלחנו להוסיף לסל. אפשר לנסות שוב.';
            // Shopify's stock-clamp rejections arrive in English; our
            // validation messages are Hebrew. Don't surface English copy.
            if (!/[֐-׿]/.test(msg)) {
              msg = 'הכמות שבחרתם אינה זמינה כרגע במלאי. אפשר לבחור כמות קטנה יותר.';
            }
            // V3 W3.7 (2026-05-02): announce error to SR live region so
            // screen-reader users hear the failure instead of guessing
            // why nothing happened.
            var srInfo = document.getElementById('screen-reader-info');
            if (srInfo) {
              srInfo.textContent = msg;
              setTimeout(function () { srInfo.textContent = ''; }, 4000);
            }
            if (err && err.yojoServerRejection) {
              // Shopify REJECTED the add (stock clamp / cart validation).
              // Re-submitting natively bypasses that rejection — /cart/add
              // (non-AJAX) does not clamp, which is how carts ended up
              // holding 7 units of a 3-unit stock. Show the message instead.
              var errEl = form.querySelector('.yojo-pdp__atc-error');
              if (!errEl) {
                errEl = document.createElement('p');
                errEl.className = 'yojo-pdp__atc-error';
                errEl.setAttribute('role', 'alert');
                if (atc && atc.parentNode) {
                  atc.parentNode.insertBefore(errEl, atc.nextSibling);
                } else {
                  form.appendChild(errEl);
                }
              }
              errEl.textContent = msg;
              // Site sweep 2026-10-14 (S-03): the message sits right under the
              // button, but on a 375x812 phone that is the foot of the screen, so
              // "…כבר אזל" rendered half below the fold and the drawer did not
              // open: the button seemed to do nothing. When any part of it is
              // off screen (or under the sticky add bar), bring it to the middle;
              // the button above it comes along.
              var errBox = errEl.getBoundingClientRect();
              var visibleBottom = window.innerHeight - (document.body.classList.contains('yojo-has-sticky-atc') ? 68 : 0);
              if (errBox.top < 0 || errBox.bottom > visibleBottom) {
                var reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
                errEl.scrollIntoView({ block: 'center', behavior: reduceMotion ? 'auto' : 'smooth' });
              }
              return;
            }
            // 2026-08-09: this used to be `form.submit()`.
            //
            // Two ways that hurt. (1) If /cart/add.js SUCCEEDED and only the
            // follow-up `?section_id=helper-cart` render failed, re-submitting
            // the same form adds the item A SECOND TIME from one click. (2) On
            // any non-network failure it navigated the shopper off the product
            // page to a raw endpoint. The native path also bypasses Shopify's
            // stock clamp — this file's own comment above records carts that
            // ended up holding 7 units of a 3-unit stock because of it.
            //
            // So: never re-POST. If the add already landed, take the shopper to
            // the cart with an idempotent GET so they can see and trust their
            // basket. If it did not, the message above is already on screen and
            // the button is re-enabled for a retry.
            if (addSucceeded) {
              window.location.assign('/cart');
            }
          })
          .finally(function () {
            window._yojoCartMutationsInFlight = Math.max(0, (window._yojoCartMutationsInFlight || 1) - 1);
            if (atc) { atc.removeAttribute('disabled'); atc.classList.remove('is-working'); }
          });
      });
    }

    var thumbs = root.querySelectorAll('[data-js-pdp-thumb]');
    var mainImage = root.querySelector('.yojo-pdp__image');
    if (thumbs.length && mainImage) {
      thumbs.forEach(function (btn) {
        btn.addEventListener('click', function () {
          var src = btn.getAttribute('data-src');
          if (src) {
            // Audit #4 (2026-07-02): the theme's initial <img> carries a srcset;
            // setting .src alone loses to srcset resolution and the main image
            // never visually changes. Drop srcset so the clicked thumb's data-src
            // wins (proper per-media data-srcset swap = Phase 2).
            mainImage.removeAttribute('srcset');
            mainImage.src = src;
          }
          root.querySelectorAll('.yojo-pdp__thumb').forEach(function (li) { li.classList.remove('is-active'); });
          var li = btn.closest('.yojo-pdp__thumb');
          if (li) li.classList.add('is-active');
        });
      });
    }

    var initialRadio = currentRadio();
    if (initialRadio) updateFromRadio(initialRadio);

    // Single-variant products have no radios, so updateFromRadio never runs and
    // the per-unit guard inside it never fires. Apply it once here too: a
    // product with no unit data was rendering the line as a bare "ליחידה" with
    // no number (coconut-cream-aroy-d).
    if (perUnitWrap && perUnitAmount && !perUnitAmount.textContent.trim()) {
      perUnitWrap.setAttribute('hidden', '');
    }

    state.announceReady = true;
  }

  function initAll() {
    document.querySelectorAll('product-page.yojo-pdp').forEach(initOne);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }
})();
